import CategoryArchive from "rialto-icons/CategoryArchive";
import CategoryCarParking from "rialto-icons/CategoryCarParking";
import CategoryCoveredCarParking from "rialto-icons/CategoryCoveredCarParking";
import CategoryCoworking from "rialto-icons/CategoryCoworking";
import CategoryIndustrial from "rialto-icons/CategoryIndustrial";
import CategoryLand from "rialto-icons/CategoryLand";
import CategoryLeisure from "rialto-icons/CategoryLeisure";
import CategoryLogistics from "rialto-icons/CategoryLogistics";
import CategoryMeeting from "rialto-icons/CategoryMeeting";
import CategoryOffice from "rialto-icons/CategoryOffice";
import CategoryOther from "rialto-icons/CategoryOther";
import CategoryOutdoorArea from "rialto-icons/CategoryOutdoorArea";
import CategoryResidential from "rialto-icons/CategoryResidential";
import CategoryRetail from "rialto-icons/CategoryRetail";
import CategoryShowroom from "rialto-icons/CategoryShowroom";
import CategoryStorage from "rialto-icons/CategoryStorage";

const categoryIcons = {
  archive: CategoryArchive,
  carParking: CategoryCarParking,
  coveredCarParking: CategoryCoveredCarParking,
  coworking: CategoryCoworking,
  industrial: CategoryIndustrial,
  land: CategoryLand,
  leisure: CategoryLeisure,
  logistical: CategoryLogistics,
  meeting: CategoryMeeting,
  office: CategoryOffice,
  other: CategoryOther,
  outdoorArea: CategoryOutdoorArea,
  residential: CategoryResidential,
  retail: CategoryRetail,
  showroom: CategoryShowroom,
  storage: CategoryStorage,
};

export default categoryIcons;
